import { ButtonProps, Button as MuiButton } from "@mui/material";

import {alpha,  styled } from "@mui/material/styles";

const AnimatedButton = styled(MuiButton)<ButtonProps>(({ theme }) => ({
  width: 'auto',
  height: "35px",
  padding: "0 10px",
  borderRadius: "6px",
  backgroundColor: alpha(theme.palette.primary.main, 0.3),
  color: "white",
  border: 'none',
  "&:hover": {
    border: 'none',
  },
  "& .text": {
    backgroundColor: theme.palette.primary.dark,
    maxWidth: 0,
    whiteSpace: "nowrap",
    overflow: "hidden",
    transition: "all 0.5s ease-in-out",
  },
  "&:hover .text": {
    maxWidth: 200,
  },
}));

export default AnimatedButton;
